import { createSlice } from "@reduxjs/toolkit";
import { normalizeTabPath } from "./tabPath";

const initialState = {
  tabs: [],
  activeTab: null,
};

const resolveTabPath = (payload) => {
  if (typeof payload === "string") {
    return normalizeTabPath(payload);
  }
  if (payload && typeof payload === "object") {
    return normalizeTabPath(payload.path || null);
  }
  return null;
};

const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    addTab(state, action) {
      const incoming = action.payload;
      const path = resolveTabPath(incoming);
      if (!path) return;

      const nextTab = typeof incoming === "object" ? { ...incoming, path } : { path };
      const existingIndex = state.tabs.findIndex((tab) => tab.path === path);

      if (existingIndex >= 0) {
        state.activeTab = state.tabs[existingIndex].path;
        return;
      } else {
        state.tabs.push(nextTab);
      }

      state.activeTab = path;
    },

    closeTab(state, action) {
      const path = resolveTabPath(action.payload);
      if (!path) return;

      const currentIndex = state.tabs.findIndex((tab) => tab.path === path);
      if (currentIndex === -1) return;

      const wasActive = state.activeTab === path;
      state.tabs.splice(currentIndex, 1);

      if (!wasActive) return;

      if (state.tabs.length === 0) {
        state.activeTab = null;
        return;
      }

      const previousTab = state.tabs[currentIndex - 1];
      const nextTab = state.tabs[currentIndex];
      state.activeTab = previousTab?.path ?? nextTab?.path ?? null;
    },

    setActiveTabByPath(state, action) {
      const path = resolveTabPath(action.payload);
      if (!path) {
        state.activeTab = null;
        return;
      }

      const exists = state.tabs.some((tab) => tab.path === path);
      state.activeTab = exists ? path : null;
    },

    clearAllTabs(state) {
      state.tabs = [];
      state.activeTab = null;
    },
  },
});

export const { addTab, closeTab, setActiveTabByPath, clearAllTabs } = tabsSlice.actions;
export default tabsSlice.reducer;
